/**
 * Ô "Giáo viên" của màn Nhập hoá đơn bằng AI — phần logic thuần, test ở
 * invoiceOcrGiaoVien.test.js.
 *
 * Backend điền sẵn `drivingTeacher` theo thứ tự: người nhận của hoá đơn đã có
 * trong DB (`matchedTeacher`) → gợi ý theo biển số (`suggestedTeacher`, lấy
 * giáo viên của hoá đơn gần nhất cùng biển). Mã gợi ý trông y hệt một người
 * đã được gán thật, nên người duyệt dễ bấm Duyệt luôn (yêu cầu kế toán,
 * 20/10/2026). Trung chọn GIỮ điền sẵn nhưng đánh dấu rõ là mã đoán, cho tới
 * khi người duyệt xác nhận (bấm Duyệt hoặc tự chọn giáo viên).
 */

/**
 * Mã giáo viên của dòng này có phải mã ĐOÁN, chưa ai xác nhận?
 * @returns {'bien-so'|'chua-ro'|null} 'bien-so' = lấy từ gợi ý biển số;
 *   'chua-ro' = không khớp nguồn nào (đợt đọc trước 13/10 còn mặc định
 *   HOANHST); null = không cần cảnh báo.
 */
export function maDoan(item) {
  if (!item || item.reviewed) return null;
  const ma = item.drivingTeacher || '';
  if (!ma) return null;
  if (item.matchedTeacher && ma === item.matchedTeacher) return null;
  if (item.suggestedTeacher && ma === item.suggestedTeacher) return 'bien-so';
  return 'chua-ro';
}

/** Chuẩn hoá để tìm: bỏ dấu tiếng Việt, đ → d, chữ hoa, gộp khoảng trắng. */
export function chuanTimKiem(s) {
  return String(s || '')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/[đĐ]/g, 'd')
    .toUpperCase()
    .replace(/\s+/g, ' ')
    .trim();
}

/** Lọc giáo viên theo chuỗi con của tên hoặc mã, gõ có dấu hay không đều ra. */
export function locGiaoVien(teachers, goTim) {
  const ds = teachers || [];
  const q = chuanTimKiem(goTim);
  if (!q) return ds;
  return ds.filter((t) => chuanTimKiem(t.name).includes(q) || chuanTimKiem(t.code).includes(q));
}
